import * as React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMobileMenu } from 'core/redux/menu/actions';
import CloseButton from '../CloseButton';
import * as styles from './CloseMenuButton.module.scss';
import { isMobileMenuOpen } from '../../redux/menu/selectors';
import useIsMobile from '../../hooks/useIsMobile';

export default function CloseMenuButton() {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const isOpen = useSelector(isMobileMenuOpen);
    const isMobile = useIsMobile();
    const handleClick = () => {
        dispatch(toggleMobileMenu());
    };

    const isHidden = !isMobile || !isOpen;
    return (
        <CloseButton
            onClick={handleClick}
            className={styles.root}
            aria-hidden={isHidden}
            tabIndex={isHidden ? -1 : 0}
        >
            <span>{formatMessage({ id: 'nav.close' })}</span>
        </CloseButton>
    );
}
